export const fileNameRegex = new RegExp('(?!self)[^A-Za-z0-9]', 'g');
